"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ElevationsChart = ElevationsChart;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _hooks = require("../hooks");
var _utils = require("../utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const chartId = 'elevation-chart';
function ElevationsChart(_ref) {
  let {
    route,
    setChart,
    onHighlight
  } = _ref;
  const chartRef = (0, _react.useRef)(null);
  const {
    toDistance
  } = (0, _hooks.useUnits)();
  (0, _react.useEffect)(() => {
    async function init() {
      const {
        Chart,
        CategoryScale,
        Filler,
        LineController,
        LineElement,
        LinearScale,
        PointElement,
        Tooltip,
        Legend
      } = await Promise.resolve().then(() => _interopRequireWildcard(require('chart.js')));
      Chart.register(LinearScale, CategoryScale, LineController, PointElement, LineElement, Tooltip, Legend, Filler);
      Chart.defaults.font.family = '"Roboto", "Helvetica", "Arial", sans-serif';
    }
    init();
  }, []);
  (0, _react.useEffect)(() => {
    let _chart;
    async function update() {
      const {
        Chart
      } = await Promise.resolve().then(() => _interopRequireWildcard(require('chart.js')));
      if (route && chartRef.current) {
        let distance = 0;
        let elevationMin = Number.MAX_VALUE;
        let elevationMax = Number.MIN_VALUE;
        const data = route.sections.reduce((res, section, sectionIndex) => {
          if ('elevations' in section) {
            for (const {
              distanceFromStart: x,
              elevation: y,
              geometryIndex
            } of section.elevations) {
              elevationMin = Math.min(elevationMin, y);
              elevationMax = Math.max(elevationMax, y);
              res.push({
                x: x + distance,
                y,
                sectionIndex,
                geometryIndex
              });
            }
          } else {
            res.push({
              x: Number.NaN,
              y: Number.NaN
            });
          }
          distance += section.distance;
          return res;
        }, []);
        const offset = Math.round(Math.max(50 - (elevationMax - elevationMin), 0) / 2);
        _chart = new Chart(chartRef.current, {
          type: 'line',
          data: {
            datasets: [{
              data,
              borderColor: 'transparent',
              backgroundColor: '#3fb37f18',
              cubicInterpolationMode: 'monotone',
              pointRadius: 0,
              fill: {
                target: 'start'
              }
            }, {
              data,
              borderColor: 'transparent',
              pointBackgroundColor: 'transparent',
              cubicInterpolationMode: 'monotone',
              pointRadius: 1,
              segment: {
                borderColor: ctx => {
                  const d = ctx.p1.parsed.x - ctx.p0.parsed.x;
                  const h = ctx.p1.parsed.y - ctx.p0.parsed.y;
                  const slopePercentage = d ? 100 * h / d : 0;
                  return (0, _utils.getElevationColor)(slopePercentage);
                }
              }
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              x: {
                type: 'linear',
                min: 0,
                max: route.distances.total,
                ticks: {
                  callback: value => toDistance(value)
                }
              },
              y: {
                type: 'linear',
                min: Math.floor(elevationMin - offset),
                max: Math.ceil(elevationMax + offset),
                offset: true,
                ticks: {
                  count: 4,
                  callback: value => `${typeof value === 'number' ? Math.round(value) : parseInt(value)} m`
                }
              }
            },
            interaction: {
              mode: 'index',
              intersect: false
            },
            plugins: {
              tooltip: {
                displayColors: false,
                callbacks: {
                  title: _ref2 => {
                    let [{
                      parsed: {
                        x
                      }
                    }] = _ref2;
                    return toDistance(x);
                  },
                  label: _ref3 => {
                    let {
                      parsed: {
                        y
                      }
                    } = _ref3;
                    return `${y} m`;
                  }
                }
              },
              legend: {
                display: false
              }
            },
            onHover: (event, elements) => {
              if (elements[0]) {
                const {
                  sectionIndex,
                  geometryIndex
                } = data[elements[0].index];
                onHighlight?.(typeof sectionIndex === 'number' && typeof geometryIndex === 'number' ? {
                  sectionIndex,
                  geometryIndex
                } : null);
              } else {
                onHighlight?.(null);
              }
            }
          }
        });
        setChart?.(_chart);
      }
    }
    update();
    return () => {
      if (_chart) _chart.destroy();
    };
  }, [route, chartRef.current]);
  return /*#__PURE__*/_react.default.createElement(StyledChart, {
    id: chartId,
    onMouseLeave: () => onHighlight?.(null),
    ref: chartRef
  });
}
const StyledChart = _styledComponents.default.canvas`
  height: 150px;
  width: 100%;
`;